import { ActivityFieldHydration } from '../../../shared/modules/activity/dtos/activity-field-hydration.dto';
import { ActivityLinkHydration } from '../../../shared/modules/activity/dtos/activity-link-hydration.dto';
import { SupplierSearchDto } from '../../suppliers/dtos/supplier-search.dto';
import { VehicleSearchDto } from '../../vehicles';

/**
 * Resolved related records for a vehicle insurance activity event, keyed by relation.
 */
export class VehicleInsuranceActivityEventHydration {
  vehicle?: ActivityFieldHydration<VehicleSearchDto>;
  supplier?: ActivityFieldHydration<SupplierSearchDto>;
  link?: ActivityLinkHydration;
}
